import apiClient from '@/services/axios'

export async function post(venueSetup) {

  var response = await apiClient.post(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-setups', venueSetup);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to post venue setup.')
}
